import { Formats, TranslationValues, useTranslations } from "next-intl"

export const useLowercaseTranslation = () => {
  const t = useTranslations()

  return (key: any, values?: TranslationValues, formats?: Partial<Formats>) =>
    t(key, values, formats).toLowerCase()
}
